<template>
  <div id="nav_back" class="w-45 h-35 flex-h flex-v-center flex-h-center margin-t-25 bg-D9EEFF radius-r-5" @click="backPressed">
    <img class="w-18 h-14" :src="require('../assets/icon_nav_back.png')" />
  </div>
</template>

<script>
export default {
  name: 'nav_back',
  props: {
    url: { default: '', type: String }
  },
  methods: {
    backPressed() {
      console.log(this.$props)
      if (this.$props.url) {
        this.$router.push({
          path: this.$props.url
        })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped></style>
